import React from 'react';
import { Box, CircularProgress, Typography, useTheme, keyframes, Paper } from '@mui/material';

// Define animation keyframes
const pulse = keyframes`
  0% {
    opacity: 0.6;
    transform: scale(0.98);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.6;
    transform: scale(0.98);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = "Loading your tax information..." 
}) => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: theme.palette.background.default,
        animation: `${fadeIn} 0.5s ease-in-out`,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 4,
          borderRadius: 2,
          maxWidth: '90%',
          width: 400,
          animation: `${pulse} 2s infinite ease-in-out`,
        }}
      >
        <Box sx={{ position: 'relative', mb: 3 }}>
          <CircularProgress
            size={80}
            thickness={4}
            sx={{
              color: theme.palette.primary.main,
            }}
          />
          <Typography
            variant="h4"
            component="span"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: theme.palette.primary.main,
              fontWeight: 'bold',
            }}
          >
            $
          </Typography>
        </Box>
        
        <Typography 
          variant="h6" 
          component="h1" 
          align="center"
          sx={{ 
            mb: 2,
            fontWeight: 'bold',
            color: theme.palette.text.primary,
          }}
        >
          US Enigma Ledger
        </Typography>
        
        <Typography 
          variant="body1" 
          align="center"
          sx={{ 
            color: theme.palette.text.secondary,
            maxWidth: '80%',
          }}
        >
          {message}
        </Typography>
      </Paper>
    </Box>
  );
};

export default LoadingScreen; 